// Legacy (Medium-sourced) posts never had a `status` field — only the old
// visible/published booleans — so this derives a sensible status from
// whichever shape a given article actually has.
export function deriveStatus(attrs) {
  if (!attrs) return "draft";
  if (attrs.status) return attrs.status;
  if (attrs.published && attrs.visible) return "published";
  if (attrs.published) return "archived";
  return "draft";
}
